import {Link, useNavigate, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import axios from "axios";
import {Col, Row} from "react-bootstrap";


const QuarterlyInspection = () => {

    let navigate = useNavigate();
    const [useId, setId] = useState()

    const [activeBuildings, setBuildings] = useState()
    const [activeSystems, setSystems] = useState()
    const [systemId, setSystemId] = useState()

    const [resp, setClientData] = useState({clients: null, buildings: null, systems: null,});

    const {id} = useParams();
    const userLogin = useSelector(state => state.userLogin);
    const {userInfo} = userLogin;

    let redirect = ''
    if (userInfo) {
        if (userInfo.group === "AdminSuper") {
            redirect = '/inspections_dash'
        } else if (userInfo.group === "Finance") {
            redirect = '/finance_active_work_orders'
        } else if (userInfo.group === "Logistics") {
            redirect = '/logistics_dash'
        } else if (userInfo.group === "Tech") {
            redirect = '/tech_work_orders'
        }
    }

    const fetchData = async () => {
        try {
            let buildings = await axios.get(`https://homesafetysolutions.pythonanywhere.com/api/quarterly_inspection_buildings/${id}/`, {
                // `http://127.0.0.1:8000/api/client_quarterly_inspections_buildings/${id}/`, {
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${userInfo.token}`
                }})
            setClientData({
                buildings: buildings.data,
            });
            setBuildings(buildings.data)
        }
        catch (err){
            if (err.response){
              console.log(err.response)
            } else if (err.request) {
                console.log(err.request)
            }
        }
        try {
            let systems = await axios.get(`https://homesafetysolutions.pythonanywhere.com/api/client_quarterly_inspections_systems/${id}/`, {
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${userInfo.token}`
                }})
            setClientData({
                systems: systems.data,
            });
            setSystems(systems.data)
            setSystemId(systems.data.map((client) => client.client))
        } catch (err){
            if (err.response){
                console.log(err.response)
            } else if (err.request) {
                console.log(err.request)
            }
        }
        try {
            let clients = await axios.get(`https://homesafetysolutions.pythonanywhere.com/api/clients/${id}/`, {
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${userInfo.token}`
                }})
            setClientData({
                data: clients.data,
            });
        } catch (err){
            if (err.response){
                console.log(err.response)
            } else if (err.request) {
                console.log(err.request)
            }
        }


        // let buildings = await axios(
        //     `https://homesafetysolutions.pythonanywhere.com/api/quarterly_inspection_buildings/${id}/`, {
        //     // `http://127.0.0.1:8000/api/client_quarterly_inspections_buildings/${id}/`, {
        //         headers: {
        //             'Content-type': 'application/json',
        //             Authorization: `Bearer ${userInfo.token}`
        //         }
        //
        //     }
        // );
        // let systems = await axios(
        //     `https://homesafetysolutions.pythonanywhere.com/api/client_quarterly_inspections_systems/${id}/`, {
        //     // `http://127.0.0.1:8000/api/client_quarterly_inspections_systems/${id}/`, {
        //         headers: {
        //             'Content-type': 'application/json',
        //             Authorization: `Bearer ${userInfo.token}`
        //         }
        //     }
        // );

        // let clients = await axios(
        //     `https://homesafetysolutions.pythonanywhere.com/api/clients/${id}/`, {
        //     // `http://127.0.0.1:8000/api/clients/${id}/`, {
        //         headers: {
        //             'Content-type': 'application/json',
        //             Authorization: `Bearer ${userInfo.token}`
        //         }
        //     }
        //
        // );
        //
        // setClientData({
        //     data: clients.data,
        //     buildings: buildings.data,
        //     systems: systems.data,
        // });
        //
        // setBuildings(buildings.data)
        // setSystems(systems.data)
        // setSystemId(systems.data.map((client) => client.client))
    }

    useEffect(() => {
        fetchData();
    }, []);

    // console.log('render');
    // if (resp.data) {
    //     console.log("d",
    //         resp.data,
    //         resp.buildings,
    //         resp.systems,
    //         systemId
    //         );
    // }

    // console.log(activeBuildings)
    // console.log(resp.data)

    return (
        <div className={"banner_heading"}>
            {
                resp.data
                    ?
                    <div>
                        <Link style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginTop: '5px'
                        }} className={'btn btn-outline-danger'}
                              to={`/inspections_initiations/${resp.data.id}/add_inspection_building_details/`}>Add
                            Building For Quarterly Inspection</Link>
                        <br/>
                        <h1>{resp.data.work_site_address} || {resp.data.project_ID}</h1>
                        <h2>QUARTERLY INSPECTION REPORT</h2>
                        <br/>
                    </div>
                    :
                    ('No Data')
            }
            <div>
                {
                    activeBuildings
                        ?
                        (
                            <div >

                                {
                                    activeBuildings?.map((val, key) => {
                                        return (
                                            <div key={key}>
                                                <Row style={{fontWeight:"900", background: 'black', color: 'white', margin:'10px 0 10px 0', padding:'15px'}}>
                                                    <Col>
                                                        {val.building_name}
                                                    </Col>
                                                    <Col>
                                                        {val.system_name}
                                                    </Col>
                                                    <Col>
                                                        <Link className={'btn btn-primary'} to={`/quarterly_inspection_buildings/update/${val.id}/`}>Update System & Building</Link>
                                                    </Col>
                                                    <Col>
                                                        <Link className={'btn btn-warning'} to={`/inspections_buildings/${val.id}/add_inspection_system_details/`}>Add System Readings</Link>
                                                    </Col>
                                                </Row>
                                                <Row style={{fontWeight:"900", background: 'darkgray', color: 'black', margin:'10px 0 10px 0', padding:'10px'}}>
                                                    <Col>
                                                        Inspection Date
                                                    </Col>
                                                    <Col>
                                                        Inspected By
                                                    </Col>
                                                    <Col>
                                                        System Readings
                                                    </Col>
                                                    <Col>
                                                        Comments
                                                    </Col>
                                                    <Col>
                                                        Update
                                                    </Col>
                                                </Row>

                                                {
                                                    activeSystems?.map((val2, key) => {
                                                        return (
                                                            <div key={key}>
                                                                {
                                                                    // console.log(val, val2)
                                                                    val.id === parseInt(val2.building_id)
                                                                        ?
                                                                        (
                                                                            <div>

                                                                                <Row style={{fontWeight:"900", background: 'lightgray', color: 'black', margin:'10px 0 0 0', padding:'10px'}}>
                                                                                    <Col>
                                                                                        {val2.inspection_date}
                                                                                    </Col>
                                                                                    <Col>
                                                                                        {val2.inspected_by}
                                                                                    </Col>
                                                                                    <Col>
                                                                                        {val2.system_readings}
                                                                                    </Col>
                                                                                    <Col>
                                                                                        {val2.comments}
                                                                                    </Col>
                                                                                    <Col>
                                                                                        <Link className={'btn btn-info btn-sm'}
                                                                                              to={`/quarterly_inspection_system/update/${val2.id}/`}>Update
                                                                                            Readings</Link>
                                                                                    </Col>
                                                                                </Row>
                                                                            </div>
                                                                        )
                                                                        :
                                                                        ('')
                                                                }

                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        )
                        :
                        ('No Building Data Has Been Entered')
                }
            </div>

        </div>
    )
}

export default QuarterlyInspection

// import React, {useState, useEffect} from 'react';
// import axios from "axios";
// import {Link, useParams} from "react-router-dom";
// import {useSelector} from "react-redux";
// import {Col, Row, Table} from "react-bootstrap";
// import Moment from "moment/moment";
//
// const QuarterlyInspection = () => {
//
//     const [clientInfo, setClientInfo] = useState('');
//     const [quarterlyInspections, setQuarterlyInspections] = useState("");
//     const [systemInspections, setSystemInspections] = useState('')
//
//     const { id } = useParams();
//
//     const userLogin = useSelector(state => state.userLogin)
//     const {userInfo} = userLogin
//
//     const getSingleClient = async () => {
//         // const {data} = await axios.get(`https://homesafetysolutions.pythonanywhere.com/api/clients/${id}/`, {
//         const {data} = await axios.get(`http://127.0.0.1:8000/api/clients/${id}/`, {
//             headers: {
//                 'Content-type': 'application/json',
//                 Authorization: `Bearer ${userInfo.token}`
//             }
//         });
//         setClientInfo(data)
//     }
//     const getQuarterlyInspectionBuildings = async () => {
//         // const {data} = await axios.get(`https://homesafetysolutions.pythonanywhere.com/api/quarterly_inspection_buildings/${id}/`, {
//         const {data} = await axios.get(`http://127.0.0.1:8000/api/client_quarterly_inspections_buildings/${id}/`, {
//             headers: {
//                 'Content-type': 'application/json',
//                 Authorization: `Bearer ${userInfo.token}`
//             }
//         });
//         setQuarterlyInspections(data)
//     }
//
//     const getQuarterlyInspectionSystems = async () => {
//         // const {data} = await axios.get(`https://homesafetysolutions.pythonanywhere.com/api/client_quarterly_inspections_systems/${id}/`, {
//         const {data} = await axios.get(`http://127.0.0.1:8000/api/client_quarterly_inspections_systems/${id}/`, {
//             headers: {
//                 'Content-type': 'application/json',
//                 Authorization: `Bearer ${userInfo.token}`
//             }
//         });
//         setSystemInspections(data)
//     }
//
//     useEffect(()=>{
//         getSingleClient();
//         getQuarterlyInspectionBuildings();
//         getQuarterlyInspectionSystems();
//     }, [])
//
//     return (
//         <div className={"banner_heading"}>
//             <Link style={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 marginTop:'5px'
//             }} className={'btn btn-outline-danger'} to={`/inspections_initiations/${clientInfo.id}/add_inspection_building_details/`}>Add Building For Quarterly Inspection</Link>
//             <br/>
//             <h1>{clientInfo.work_site_address} || {clientInfo.project_ID}</h1>
//             <h2>QUARTERLY INSPECTION REPORT</h2>
//             <br/>
//
//             <div>
//                 {quarterlyInspections
//                     ?
//                     <Table striped bordered hover>
//                         <thead>
//                         <tr>
//                             <th>Building</th>
//                             <th>System</th>
//                         </tr>
//                         </thead>
//                         {quarterlyInspections?.map((val, key) => {
//                             return (
//                                 <tbody>
//                                 <tr key={key}>
//                                     <td>{val.building_name}</td>
//                                     <td>{val.system_name}</td>
//                                     <td><Link className={'btn btn-primary'} to={`/quarterly_inspection_buildings/update/${val.id}/`}>Update System & Building</Link></td>
//                                     <td><Link className={'btn btn-info'} to={`/inspections_buildings/${val.client}/add_inspection_system_details/`}>Add System Readings</Link></td>
//                                 </tr>
//                                 </tbody>
//                             )
//                         })}
//                     </Table>
//
//                     :
//                     ("Data has not yet been entered")
//                 }
//                 {systemInspections
//                     ?
//                     <div>
//                         <Row>
//                             <Col>
//                                 Inspection Date
//                             </Col>
//                             <Col>
//                                 Inspected By
//                             </Col>
//                             <Col>
//                                 System Readings
//                             </Col>
//                             <Col>
//                                 Comments
//                             </Col>
//                             <Col>
//                                 Update
//                             </Col>
//                         </Row>
//                         {systemInspections?.map((val, key) => {
//                             return(
//                                 <Row key={key}>
//                                     <Col>
//                                         {val.inspection_date}
//                                     </Col>
//                                     <Col>
//                                         {val.inspected_by}
//                                     </Col>
//                                     <Col>
//                                         {val.system_readings}
//                                     </Col>
//                                     <Col>
//                                         {val.comments}
//                                     </Col>
//                                     <Col>
//                                         <Link className={'btn btn-info'} to={`/quarterly_inspection_system/update/${val.id}/`}>Update Readings</Link>
//                                     </Col>
//                                 </Row>
//                             )
//                         })}
//                     </div>
//                     :
//                     ('System Data Has Not Yet Been Entered')
//                 }
//
//             </div>
//
//         </div>
//     )
// }
//
// export default QuarterlyInspection
